/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, state: NonNullable<unknown> }} Explorer_Kanban_State_Updated_ToastInputs */

const en_explorer_kanban_state_updated_toast = /** @type {(inputs: Explorer_Kanban_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated "${i?.name}" state to "${i?.state}"`)
};

const fr_explorer_kanban_state_updated_toast = /** @type {(inputs: Explorer_Kanban_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Etat de "${i?.name}" mis a jour vers "${i?.state}"`)
};

const de_explorer_kanban_state_updated_toast = /** @type {(inputs: Explorer_Kanban_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Status "${i?.name}" auf "${i?.state}" aktualisiert`)
};

const it_explorer_kanban_state_updated_toast = /** @type {(inputs: Explorer_Kanban_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aggiornato lo stato "${i?.name}" a "${i?.state}"`)
};

const ru_explorer_kanban_state_updated_toast = /** @type {(inputs: Explorer_Kanban_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Состояние "${i?.name}" обновлено до "${i?.state}"`)
};

const es_explorer_kanban_state_updated_toast = /** @type {(inputs: Explorer_Kanban_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se actualizó el estado "${i?.name}" a "${i?.state}"`)
};

const zh_cn2_explorer_kanban_state_updated_toast = /** @type {(inputs: Explorer_Kanban_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已将“${i?.name}”状态更新为“${i?.state}”。`)
};

const ja_explorer_kanban_state_updated_toast = /** @type {(inputs: Explorer_Kanban_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」の状態を「${i?.state}」に更新しました`)
};

const hi_explorer_kanban_state_updated_toast = /** @type {(inputs: Explorer_Kanban_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" की स्थिति को "${i?.state}" में अपडेट किया गया।`)
};

const pt_pt2_explorer_kanban_state_updated_toast = /** @type {(inputs: Explorer_Kanban_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estado "${i?.name}" atualizado para "${i?.state}"`)
};

/**
* | output |
* | --- |
* | "Updated \"{name}\" state to \"{state}\"" |
*
* @param {Explorer_Kanban_State_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_state_updated_toast = /** @type {((inputs: Explorer_Kanban_State_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_State_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_kanban_state_updated_toast(inputs)
	if (locale === "de") return de_explorer_kanban_state_updated_toast(inputs)
	if (locale === "it") return it_explorer_kanban_state_updated_toast(inputs)
	if (locale === "ru") return ru_explorer_kanban_state_updated_toast(inputs)
	if (locale === "es") return es_explorer_kanban_state_updated_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_kanban_state_updated_toast(inputs)
	if (locale === "ja") return ja_explorer_kanban_state_updated_toast(inputs)
	if (locale === "hi") return hi_explorer_kanban_state_updated_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_kanban_state_updated_toast(inputs)
	return en_explorer_kanban_state_updated_toast(inputs)
});